document.addEventListener('DOMContentLoaded', function() {
    // Obtener los elementos una vez que el DOM esté completamente cargado
    const hamburguerIcon = document.querySelector('.hamburguer-icon');
    const drawerBackground = document.querySelector('.drawer-background');
    const botonCerrar = document.querySelector('.boton-cerrar .btn-close');

    // Agregar el evento de clic al icono de hamburguesa
    hamburguerIcon.addEventListener('click', function() {
        drawerBackground.classList.add('active');
    });

    // Agregar el evento de clic al botón de cierre
    botonCerrar.addEventListener('click', function() {
        drawerBackground.classList.remove('active');
    });

    document.addEventListener("scroll", function() {
        const header = document.getElementById("header");
        if (window.scrollY > 10) { // Cambia '10' según el punto en el que quieras que aparezca la sombra
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    });

});
